import { ADMIN_NOTES_FORM } from './index';
import { Action } from '../action';
import { ServiceMetaInfo } from '@shared/core';

export class AdminNotesFormInitAction implements Action {
	readonly type = ADMIN_NOTES_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminNotesFormDestroyAction implements Action {
	readonly type = ADMIN_NOTES_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminNotesFormClickSubmitAction implements Action {
	readonly type = ADMIN_NOTES_FORM.CLICK_SUBMIT;
	constructor(
		public payload: ServiceMetaInfo,
		public correlationId?: number
	) {}
}

export class AdminNotesFormUpdateAction implements Action {
	readonly type = ADMIN_NOTES_FORM.UPDATE;
	constructor(
		public payload: ServiceMetaInfo,
		public correlationId?: number
	) {}
}

export class AdminNotesFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_NOTES_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminNotesFormUpdateFailureAction implements Action {
	readonly type = ADMIN_NOTES_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
